import { E164 as PREFIX, DEFAULT_PER_PAGE_MEDIUM } from '../const';
import { E164_SET_LOADING, E164_SET_LIST } from '../actions/actionTypes';

const initialState = {
    list: [],
    loading: true,
    page: 1,
    count: 0,
    per_page: DEFAULT_PER_PAGE_MEDIUM
};

const handlers = {
    [E164_SET_LOADING]: (state, { payload }) => ({ ...state, loading: payload }),
    [E164_SET_LIST]: (state, { payload: { list, page, perPage, count } }) => ({
        ...state,
        list,
        page,
        per_page: perPage,
        count,
        loading: false,
    }),
    DEFAULT: state => state
};

export default (state = initialState, action) => {
    const handle = handlers[action.type] || handlers.DEFAULT;
    return handle(state, action);
}